import React, { useState } from "react";
import ImageBanner from "@/components/ImageBanner";
import Footer from "@/layout/Footer";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { authApi } from "@/api/auth.api";
import { useNavigate } from "react-router-dom";
import DesktopRegisterForm from "@/components/DesktopRegisterForm";
import MobileRegisterForm from "@/components/MobileRegisterForm";
import * as Yup from "yup";

const schema = Yup.object().shape({
	name: Yup.string().required("Full Name is required"),
	email: Yup.string().email("Invalid email").required("Email is required"),
	password: Yup.string()
		.required("Password is required")
		.min(8, "Password must be at least 8 characters")
		.matches(/[A-Z]/, "Must include uppercase letter")
		.matches(/[a-z]/, "Must include lowercase letter")
		.matches(/[0-9]/, "Must include a number")
		.matches(/[^A-Za-z0-9]/, "Must include a symbol"),
	terms: Yup.boolean().oneOf([true], "You must accept the terms"),
});

const SignUp = () => {
	const [showDesktopPassword, setShowDesktopPassword] = useState(false);
	const desktopForm = useForm({
		resolver: yupResolver(schema),
	});

	const [showMobilePassword, setShowMobilePassword] = useState(false);
	const mobileForm = useForm({
		resolver: yupResolver(schema),
	});
	const navigate = useNavigate();

	const onSubmit = async (data) => {
		//	console.log("Register data:", data);

		try {
			await authApi._register(data);
			navigate("/login");
		} catch (error) {
			console.error("Registration failed:", error);
		}
	};

	return (
		<>
			<div className="relative flex flex-col hidden lg:flex w-full h-auto items-center justify-center mt-[40px]">
				<div className="w-full max-w-[1440px] flex items-center justify-between px-8">
					<ImageBanner
						type="desktop"
						title="Create Account"
						containerWidth="w-full max-w-[1440px] flex items-center"
						titlePosition={{ top: "top-[100px]", left: "left-[60px]" }}
					/>
				</div>
			</div>
			<div className="flex justify-center mt-[28px] h-[700px] hidden lg:flex">
				<div className="w-[361px] h-auto flex flex-col gap-[16px] rounded-[8px] pt-[16px] pr-[20px] pb-[32px] pl-[20px]">
					<DesktopRegisterForm
						register={desktopForm.register}
						errors={desktopForm.formState.errors}
						handleSubmit={desktopForm.handleSubmit}
						onSubmit={onSubmit}
						showPassword={showDesktopPassword}
						setShowPassword={setShowDesktopPassword}
					/>
					{/* OR */}
					<div className="w-[321px] h-[32px] flex items-center gap-[8px] justify-center ">
						<p className="text-[14px] font-[400] font-montserrat leading-[1] text-[#193D34]">
							OR
						</p>
					</div>
					{/* Google Login */}
					<button className="w-[321px] h-[32px] flex items-center justify-center gap-[10px] rounded-[24px] px-[6px] py-[8px] border bg-[#F1F6E9]">
						<img
							src="/assets/login/google.svg"
							alt="Google Icon"
							className="w-[19px] h-[19px]"
						/>
						<span className="text-[13px] font-[500] font-montserrat text-[#193D34] text-center">
							Login with Google
						</span>
					</button>
				</div>
			</div>
			{/* Mobile View  */}
			<ImageBanner type="mobile" title="Create Account" />
			<div className="flex justify-center mt-[40px] lg:hidden h-[607px]">
				<div className="w-[95%] max-w-[361px] flex flex-col gap-[16px] rounded-[8px] pt-[16px] pr-[20px] pb-[32px] pl-[20px]">
					<MobileRegisterForm
						register={mobileForm.register}
						errors={mobileForm.formState.errors}
						handleSubmit={mobileForm.handleSubmit}
						onSubmit={onSubmit}
						showPassword={showMobilePassword}
						setShowPassword={setShowMobilePassword}
					/>
					{/* OR */}
					<div className="w-full h-[32px] flex items-center justify-center gap-[10px]">
						<p className="text-[14px] font-[400] font-montserrat leading-[1] text-[#193D34]">
							OR
						</p>
					</div>

					{/* Google Login */}
					<button className="w-full h-[32px] flex items-center justify-center gap-[10px] rounded-[24px] px-[6px] py-[8px] border bg-[#F1F6E9]">
						<img
							src="/assets/login/google.svg"
							alt="Google Icon"
							className="w-[19px] h-[19px]"
						/>
						<span className="text-[13px] font-[500] font-montserrat text-[#193D34] text-center">
							Login with Google
						</span>
					</button>
				</div>
			</div>

			<Footer />
		</>
	);
};

export default SignUp;
